import { useTranslation as useTranslationI18Vue } from 'i18next-vue'
import type { KeyPrefix, TFunction } from 'i18next'

export type StronglyTypedUseTranslation<
  TPrefix extends KeyPrefix<'application'>,
> = TFunction<'application', TPrefix>

// this is workaround to fix an issue where importing i18next-vue in a component breaks types
// somehow wrapping the composable in our own fixes the issue.
// we also made it strongly typed
export default function useTranslation<
  TPrefix extends KeyPrefix<'application'> = undefined,
>(keyPrefix?: TPrefix): StronglyTypedUseTranslation<TPrefix> {
  const { t } = useTranslationI18Vue('application', {
    keyPrefix,
  })

  return t
}
